import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';


export const fetchAffLeads = createAsyncThunk(
    'aff/fetchAffLeads',
    async ({ token, searchQuery, searchField, filters, limit = 10, offset = 0 }, { rejectWithValue }) => {
        try {
            let url = `/api/aff_leads/get_leads_status?token=${token}&limit=${limit}&offset=${offset}`
            if (searchQuery && searchField) {
                url += `${searchField}=${searchQuery}`
            }

            if (filters) {
                Object.keys(filters).forEach(key => {
                    if (filters[key].includes(',')) {
                        const values = filters[key].split(',');
                        values.forEach(value => {
                            url += `&${key}=${value}`
                        })
                        return
                    }

                    if (filters[key] !== 'all' && filters[key] !== '')
                        return url += `&${key}=${filters[key]}`
                })
            }

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${token}`, // Вставьте ваш токен аутентификации здесь
                },
            });
            const data = await response.json();
            if (!response.ok) {
                throw new Error(data.message || 'Не удалось получить лидов');
            }
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    });

export const affLeadsSlice = createSlice({
    name: 'affLeads',
    initialState: {
        leads: [],
        filters: [],
        search: {
            query: '',
            field: 'first_name',
        },
        total: 0,
        status: 'idle',
        currentPage: 1,
        perPage: 10,
        error: null
    },
    reducers: {
        setLeads: (state, action) => {
            state.leads = action.payload.leads;
        },
        handleSearchQuery: (state, action) => {
            state.search.query = action.payload;
        },
        handleSearchField: (state, action) => {
            state.search.field = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setFilters: (state, action) => {
            state.filters = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAffLeads.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchAffLeads.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.leads = action.payload.leads;
                state.total = action.payload.total;
            })
            .addCase(fetchAffLeads.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export const { setLeads, handleSearchQuery, setFilters, handleSearchField, setCurrentPage } = affLeadsSlice.actions;

export default affLeadsSlice.reducer;